import { TwcProduct } from '../../../twc-products';

export const WATER_VAPOR_PRODUCT_DATA: TwcProduct = {
  id: 'global-water-vapor-satellite',
  defaultProductId: 'sat-wv-boeing',
  productName: 'Weather-Water-Vapor-Sat-TWC',
  label: 'Global Water Vapor Satellite',
  weatherType: 'SAT_VAPOR',
  description: 'TWC product (raster) - Global Water Vapor Satellite Image',
  series: 'Observation',
  timeSlicePeriodInMinutes: 15,
  lodMax: 7,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 85
};
